import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseCitiesProps<T> = {
  filters?: {
    search?: string
  }
  mapper?: (data: any) => T,
}

export const useCities = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseCitiesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['cities', search],
    queryFn: () => {
      return privateAxios.get(`/geo/cities`, {
        params: {
          search
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
